import { useEffect } from 'react';
import { logger } from '../../resources/Logger';

const IN_APP_BROWSER_BYPASS_KEY = 'inAppBrowserBypass';

export function useInAppBrowserBypass(redirectUrl?: string) {
  useEffect(
    function redirectToExternalBrowser() {
      if (typeof window === 'undefined') {
        return;
      }

      const hasRedirected = sessionStorage.getItem(IN_APP_BROWSER_BYPASS_KEY);

      if (hasRedirected) {
        return;
      }

      const ua = navigator.userAgent.toLowerCase();
      const originalUrl = redirectUrl ?? window.location.href;

      logger.debug({
        ua,
        originalUrl,
        message: 'In-app browser detected, redirecting...',
      });

      if (ua.includes('kakaotalk/')) {
        sessionStorage.setItem(IN_APP_BROWSER_BYPASS_KEY, 'true');

        // 카카오톡: 전체 URL을 인코딩
        const encodedUrl = encodeURIComponent(originalUrl);
        location.href = `kakaotalk://web/openExternal?url=${encodedUrl}`;
      } else if (ua.includes('line/')) {
        sessionStorage.setItem(IN_APP_BROWSER_BYPASS_KEY, 'true');

        // Line: 원본 URL에 파라미터 추가 후 직접 리다이렉트
        const sep = originalUrl.includes('?') ? '&' : '?';
        const urlWithParam = `${originalUrl}${sep}openExternalBrowser=1`;

        location.href = urlWithParam;
      }

      // 추가 내부 브라우저 대응이 필요할 경우 여기에 분기 추가 가능
    },
    [redirectUrl],
  );
}
